import { render, staticRenderFns } from "./Form5ProcessHeader.vue?vue&type=template&id=077c9f2a&scoped=true"
import script from "./Form5ProcessHeader.vue?vue&type=script&lang=ts"
export * from "./Form5ProcessHeader.vue?vue&type=script&lang=ts"
import style0 from "./Form5ProcessHeader.vue?vue&type=style&index=0&id=077c9f2a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077c9f2a",
  null
  
)

export default component.exports